import './App.css';
import TodoApp from './Components/ToDo';
import './Components/ToDo.css';

function App() {
  return (
    <div className="App">
      <h1>React ToDo App</h1>
      <TodoApp />
    </div>
  );
}

export default App;
